var SENTRY_RELEASE;SENTRY_RELEASE={name: "PropSwap-staging", version: "2.13.10"};